import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '@tectonics/commons/customer-form/get-phone-number-normalizer';
import { normalizeBrazilianDocument } from '@tectonics/prs/brazil';

const BRAZIL: Country = {
  code: 'br',
  termsAndConditionsUrl: 'https://www.ebanx.com/br/termos',
  customerForm: {
    documentNormalizer: normalizeBrazilianDocument,
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(13),
    },
  },
};

export default BRAZIL;
